/* eslint-disable */
export default {
  logging: '記錄中...',
  logCall: '記錄通話',
  editLog: '編輯記錄',
  select: '選擇相符的記錄',
  OnHold: '保留',
  Ringing: '響鈴',
  CallConnected: '通話已連線',
  unknownUser: '未知的使用者',
  unknownNumber: '匿名',
  unavailable: '無法接聽通話',
  viewDetails: '檢視詳細資訊',
  addEntity: '建立',
  addLog: '記錄',
  text: '文字',
  call: '通話',
  addContact: '新增連絡人',
  missedCall: '未接',
  inboundCall: '撥入電話',
  outboundCall: '撥出電話',
  from: '來自',
  to: '撥給',
  hangup: '掛斷',
  accept: '回答',
  toVoicemail: '至語音信箱',
  anonymous: '匿名',
  mergeToConference: '與進行中的通話合併',
  hold: '通話保留',
  unhold: '取消保留',
  transfer: '轉接',
  reject: '拒絕',
  switchCall: '將通話切換至這個應用程式',
  callSwitch: '通話切換',
  comfirmContext:
    '您目前正使用 {displayName} 通話。是否要在此裝置上繼續進行通話？',
  comfirmCancelButton: '取消',
  comfirmOKButton: '切換',
  ignore: '忽略',
  holdAndAnswer: '保留通話並接聽',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
